import styles from "./SegmentedControl.module.css";

const SegmentedControl = ({

    label,

    value,

    options = [],

    onChange,

}) => {

    return (

        <div className={styles.wrapper}>

            {label && (

                <label className={styles.label}>

                    {label}

                </label>

            )}

            <div className={styles.container}>

                {options.map((item) => (

                    <button
                        key={String(item.value)}
                        type="button"
                        className={`${styles.item} ${
                            value === item.value
                                ? styles.active
                                : ""
                        }`}
                        onClick={() => onChange(item.value)}
                    >
                        {item.label}
                    </button>
                ))}

            </div>

        </div>

    );

};

export default SegmentedControl;